import React from 'react'

import { RealEstateFeatures } from '../../../../../@types/types'
import { InsertionFlowScreensProps } from '../../../../../@types/props-types'
import { SCREEN_FLAT_SHARE_ROOM_PROPERTIES, SCREENS } from '../../../../../services/domain/wizardScreens'
import { AbstractScreenValidationResult } from '../../../../../@types/validation-types'
import ScreenContainer from '../../../../common/containers/screenContainer/ScreenContainer'
import { ScreenLayout } from '../../../../common/containers/screenLayout/ScreenLayout'
import EstateFeatures from '../commonFields/estateFeatures/EstateFeatures'
import SmokingAllowed from './fields/smokingAllowed/SmokingAllowed'
import Furnishing from './fields/furnishing/Furnishing'

const screen = SCREENS[SCREEN_FLAT_SHARE_ROOM_PROPERTIES]

const FlatShareRoomProperties: React.FC<InsertionFlowScreensProps<AbstractScreenValidationResult>> = (props) => {
  const accessibilityRealEstateFeatures = [
    { translationKey: 'ELEVATOR', property: RealEstateFeatures.ELEVATOR },
    { translationKey: 'STEPLESS_ACCESSIBLE', property: RealEstateFeatures.HANDICAPPED_ACCESSIBLE },
  ]
  const outsideAreaRealEstateFeatures = [
    { translationKey: 'BALCONY_TERRACE', property: RealEstateFeatures.BALCONY_TERRACE },
    { translationKey: 'SHARED_GARDEN', property: RealEstateFeatures.SHARED_GARDEN },
  ]
  return (
    <ScreenContainer containerId={screen.id} className='' onNavigate={props.onNavigate} screen={screen}>
      <ScreenLayout
        id={`${screen.id}-desk-tooltip`}
        headline={'wizard.screen.flatShareRoomProperties.header'}
        screenName={screen.name}
      >
        <SmokingAllowed {...props} screenName={screen.name} />
        <Furnishing {...props} screenName={screen.name} />
        <EstateFeatures
          {...props}
          screenName={screen.name}
          estateFeatures={outsideAreaRealEstateFeatures}
          labelTranslationKey='outsideAreaFeatures'
          subId='outside-area'
          wrapperClassName='margin-top-l'
        />
        <EstateFeatures
          {...props}
          screenName={screen.name}
          estateFeatures={accessibilityRealEstateFeatures}
          labelTranslationKey='accessibilityFeatures'
          subId='accessibility'
          wrapperClassName='margin-top-l'
        />
      </ScreenLayout>
    </ScreenContainer>
  )
}

export default FlatShareRoomProperties
